import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { c as cl } from './clsx.m.js';
import { a as createLogger, i as isTriggerEvent, e as emitEvent, l as logDeprecatedEventOnce } from './utils.js';
import { d as defineCustomElement$2 } from './cl-icon2.js';

// Constants
const component = 'cl-tab';

const clTabCss = ".sc-cl-tab-h{display:flex;outline:none;position:relative}.tab.sc-cl-tab-h{color:rgb(var(--font-color-onlight-default));cursor:pointer;font-family:var(--font-family-ui);font-size:var(--font-size-body-1)}.tab--active.sc-cl-tab-h .tab__label.sc-cl-tab{color:rgba(var(--font-color-onlight-brand))}.tab--disabled.sc-cl-tab-h{cursor:not-allowed}.tab--disabled.sc-cl-tab-h .tab__label.sc-cl-tab{color:rgba(var(--font-color-onlight-muted))}.tab--disabled.sc-cl-tab-h .tab__icon.sc-cl-tab{opacity:var(--opacity-3, 0.5)}.tab--hidden.sc-cl-tab-h{display:none}.tab.sc-cl-tab-h:not(.tab--disabled):hover .tab__label.sc-cl-tab{color:rgba(var(--font-color-onlight-brand))}.tab.sc-cl-tab-h:not(.tab--disabled):hover .tab.sc-cl-tab cl-icon.sc-cl-tab{color:rgba(var(--color-brand-600))}.tab.sc-cl-tab-h:not(.tab--disabled):focus-visible .tab__label.sc-cl-tab,.tab.sc-cl-tab-h:not(.tab--disabled):focus .tab__label.sc-cl-tab,.tab.sc-cl-tab-h:not(.tab--disabled):focus-within .tab__label.sc-cl-tab{border:var(--border-width) solid rgba(var(--system-color-focus));border-radius:var(--border-radius-interactive-large);color:rgba(var(--font-color-onlight-brand))}.tab.sc-cl-tab{background-color:transparent;border:none;color:rgba(var(--color-brand-600))}.tab__label.sc-cl-tab{align-items:center;border:var(--border-width) solid transparent;border-radius:var(--border-radius-interactive-large);display:flex;margin:0 var(--spacing-quarter) calc(var(--spacing-1) + var(--spacing-quarter));padding:var(--spacing-half) var(--spacing-2);transition:all 0.3s ease-in-out;white-space:nowrap}.tab__icon.sc-cl-tab{margin-right:var(--spacing-1)}";

const ClTab$1 = /*@__PURE__*/ proxyCustomElement(class ClTab extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.clSelect = createEvent(this, "clSelect", 7);
    this.select = createEvent(this, "tabActivated", 7);
    /**
     * Object containing custom consoleLogger functions.
     */
    this.logger = createLogger(component);
    /**
     * Handles setting the active state to true
     */
    this.handleTrigger = (event) => {
      if (isTriggerEvent(event)) {
        this.active = true;
      }
    };
    /**
     * Handles preventing the CSS :focus style from being set on click
     */
    this.handleMouseDown = (event) => {
      event.preventDefault();
    };
    this.active = false;
    this.disabled = false;
    this.iconName = '';
    this.label = '';
    this.name = '';
  }
  /**
   * Handles emitting the clSelect event when the tab becomes active
   */
  handleActive(active) {
    var _a;
    if (active) {
      if (this.disabled) {
        this.active = false;
      }
      else {
        const index = (_a = this.element.attributes.getNamedItem('index')) === null || _a === void 0 ? void 0 : _a.value;
        emitEvent(this, 'clSelect', Object.assign({ component, active, disabled: this.disabled, name: this.name }, (index ? { index } : {})), this.element);
      }
    }
  }
  /**
   * Every time the component is connected to the DOM:
   * - Console log deprecation warnings;
   */
  connectedCallback() {
    logDeprecatedEventOnce(this.logger, 'tabActivated', 'clSelect');
  }
  /**
   * Handles changing the active state when another tab emits the clSelect event
   */
  handleTabSelected(event) {
    var _a;
    const index = event.detail.index;
    const myIndex = (_a = this.element.attributes.getNamedItem('index')) === null || _a === void 0 ? void 0 : _a.value;
    if (index && myIndex && !(event.detail.name === this.name && +index === +myIndex)) {
      this.active = false;
      this.element.blur();
    }
  }
  render() {
    const { active, disabled, iconName, label } = this;
    return (h(Host, { class: cl('tab', {
        'tab--active': active && !disabled,
        'tab--disabled': disabled,
      }), tabIndex: disabled ? '-1' : '0', onClick: this.handleTrigger, onKeyPress: this.handleTrigger, onMouseDown: this.handleMouseDown }, h("span", { class: 'tab__label' }, iconName && h("cl-icon", { class: 'tab__icon', name: iconName, size: 2 }), label, h("slot", null))));
  }
  get element() { return this; }
  static get watchers() { return {
    "active": ["handleActive"]
  }; }
  static get style() { return clTabCss; }
}, [6, "cl-tab", {
    "active": [1028],
    "disabled": [4],
    "iconName": [1, "icon-name"],
    "label": [1],
    "name": [1]
  }, [[16, "clSelect", "handleTabSelected"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-tab", "cl-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-tab":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClTab$1);
      }
      break;
    case "cl-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const ClTab = ClTab$1;
const defineCustomElement = defineCustomElement$1;

export { ClTab, defineCustomElement };

//# sourceMappingURL=cl-tab.js.map